import { createRouter, createWebHistory } from 'vue-router';

/* istanbul ignore next */
const WelcomeScreen = () => import(/* webpackChunkName: "WelcomeScreen" */ '@/components/core/WelcomeScreen.vue');
/* istanbul ignore next */
const NotFoundScreen = () => import(/* webpackChunkName: "NotFoundScreen" */ '@/components/core/NotFoundScreen.vue');
/* istanbul ignore next */
const OrderScreen = () => import(/* webpackChunkName: "OrderScreen" */ '@/components/order/OrderScreen.vue');
/* istanbul ignore next */
const DynaformSearchScreen = () => import(/* webpackChunkName: "DynaformSearchScreen" */ '@/components/core/dynamic/search/DynaformSearchScreen.vue');
/* istanbul ignore next */
const DynaformEditScreen = () => import(/* webpackChunkName: "DynaformEditScreen" */ '@/components/core/dynamic/DynaformEditScreen.vue');
/* istanbul ignore next */
const DynaformNewScreen = () => import(/* webpackChunkName: "DynaformNewScreen" */ '@/components/core/dynamic/DynaformNewScreen.vue');
/* istanbul ignore next */
const LoginScreen = () => import(/* webpackChunkName: "LoginScreen" */ '@/components/login/LoginScreen.vue');
/* istanbul ignore next */
const PurchaseOrderSearchScreen = () => import(/* webpackChunkName: "PurchaseOrderSearchScreen" */ '@/components/headerDetail/PurchaseOrderSearchScreen.vue');
/* istanbul ignore next */
const PurchaseOrderScreen = () => import(/* webpackChunkName: "PurchaseOrderScreen" */ '@/components/headerDetail/PurchaseOrderScreen.vue');
/* istanbul ignore next */
const TransferScreen = () => import(/* webpackChunkName: "TransferScreen" */ '@/components/headerDetail/TransferScreen.vue');
/* istanbul ignore next */
const TransferSearchScreen = () => import(/* webpackChunkName: "TransferSearchScreen" */ '@/components/headerDetail/TransferSearchScreen.vue');
/* istanbul ignore next */
const TransferWorksheetEntryScreen = () => import(/* webpackChunkName: "TransferWorksheetEntryScreen" */ '@/components/shipping/TransferWorksheetEntryScreen.vue');
/* istanbul ignore next */
const ReportTemplateSearchScreen = () => import(/* webpackChunkName: "ReportTemplateSearchScreen" */ '@/components/reportTemplate/ReportTemplateSearchScreen.vue');
/* istanbul ignore next */
const ReportTemplateEditScreen = () => import(/* webpackChunkName: "ReportTemplateEditScreen" */ '@/components/reportTemplate/ReportTemplateEditScreen.vue');
/* istanbul ignore next */
const TagFormatScreen = () => import(/* webpackChunkName: "TagFormatScreen" */ '@/components/tagFormat/TagFormatScreen.vue');
/* istanbul ignore next */
const MiscAREntry = () => import(/* webpackChunkName: "MiscAREntry" */ '@/components/customer/MiscAREntry.vue');
/* istanbul ignore next */
const MultiplePaymentsEntry = () => import(/* webpackChunkName: "MultiplePaymentsEntry" */ '@/components/customer/MultiplePaymentsEntry.vue');
/* istanbul ignore next */
const ProductEditScreen = () => import(/* webpackChunkName: "ProductEditScreen" */ '@/components/core/mainEdit/ProductEditScreen.vue');
/* istanbul ignore next */
const ProductSearchScreen = () => import(/* webpackChunkName: "ProductSearchScreen" */ '@/components/core/mainEdit/ProductSearchScreen.vue');
/* istanbul ignore next */
const ProductLookup = () => import(/* webpackChunkName: "ProductLookup" */ '@/components/core/common/ProductLookup.vue');
/* istanbul ignore next */
const OrderSearchScreen = () => import(/* webpackChunkName: "OrderSearchScreen" */ '@/components/order/OrderSearchScreen.vue');
/* istanbul ignore next */
const ReservedInventorySearchScreen = () => import(/* webpackChunkName: "ReservedInventorySearchScreen" */ '@/components/products/ReservedInventorySearchScreen.vue');
/* istanbul ignore next */
const GlEntry = () => import(/* webpackChunkName: "GlEntry" */ '@/components/core/queueMotif/GlEntry.vue');
/* istanbul ignore next */
const JournalCodeScreen = () => import(/* webpackChunkName: "JournalCodeScreen" */ '@/components/core/queueMotif/JournalCodeScreen.vue');
/* istanbul ignore next */
const JournalCodeEntry = () => import(/* webpackChunkName: "JournalCodeEntry" */ '@/components/accounting/JournalCodeEntry.vue');
/* istanbul ignore next */
const GlReportGroupScreen = () => import(/* webpackChunkName: "GlReportGroupScreen" */ '@/components/accounting/GlReportGroupScreen.vue');
/* istanbul ignore next */
const SalespersonBudgetSearchScreen = () => import(/* webpackChunkName: "SalespersonBudgetSearchScreen" */ '@/components/accounting/SalespersonBudgetSearchScreen.vue');
/* istanbul ignore next */
const SalespersonBudgetScreen = () => import(/* webpackChunkName: "SalespersonBudgetScreen" */ '@/components/accounting/SalespersonBudgetScreen.vue');
/* istanbul ignore next */
const InvoiceSearchScreen = () => import(/* webpackChunkName: "InvoiceSearchScreen" */ '@/components/accounting/InvoiceSearchScreen.vue');
/* istanbul ignore next */
const InvoiceScreen = () => import(/* webpackChunkName: "InvoiceScreen" */ '@/components/accounting/InvoiceScreen.vue');
/* istanbul ignore next */
const GlTranSearchScreen = () => import(/* webpackChunkName: "GlTranSearchScreen" */ '@/components/accounting/GlTranSearchScreen.vue');
/* istanbul ignore next */
const CashDrawerBalanceSearchScreen = () => import(/* webpackChunkName: "CashDrawerBalanceSearchScreen" */ '@/components/accounting/CashDrawerBalanceSearchScreen.vue');
/* istanbul ignore next */
const CashierActivationScreen = () => import(/* webpackChunkName: "CashierActivationScreen" */ '@/components/accounting/CashierActivationScreen.vue');
/* istanbul ignore next */
const CashDrawerCloseScreen = () => import(/* webpackChunkName: "CashDrawerCloseScreen" */ '@/components/accounting/CashDrawerCloseScreen.vue');
/* istanbul ignore next */
const ReportScreen = () => import(/* webpackChunkName: "ReportScreen" */ '@/components/report/ReportScreen.vue');
/* istanbul ignore next */
const ReportSearchScreen = () => import(/* webpackChunkName: "ReportSearchScreen" */ '@/components/report/ReportSearchScreen.vue');
/* istanbul ignore next */
const ProcessScreen = () => import(/* webpackChunkName: "ProcessScreen" */ '@/components/admin/ProcessScreen.vue');
/* istanbul ignore next */
const UnrestrictedTransferScreen = () => import(/* webpackChunkName: "UnrestrictedTransferScreen" */ '@/components/customer/UnrestrictedTransferScreen.vue');
/* istanbul ignore next */
const DataGeneratorSearchScreen = () => import(/* webpackChunkName: "DataGeneratorSearchScreen" */ '@/components/job/DataGeneratorSearchScreen.vue');
/* istanbul ignore next */
const DataGeneratorScreen = () => import(/* webpackChunkName: "DataGeneratorScreen" */ '@/components/job/DataGeneratorScreen.vue');
/* istanbul ignore next */
const TruckRouteSearchScreen = () => import(/* webpackChunkName: "TruckRouteSearchScreen" */ '@/components/shipping/TruckRouteSearchScreen.vue');
/* istanbul ignore next */
const TruckRouteScreen = () => import(/* webpackChunkName: "TruckRouteScreen" */ '@/components/shipping/TruckRouteScreen.vue');
/* istanbul ignore next */
const VendorChargebackSearchScreen = () => import(/* webpackChunkName: "VendorChargebackSearchScreen" */ '@/components/headerDetail/VendorChargebackSearchScreen.vue');
/* istanbul ignore next */
const VendorChargebackScreen = () => import(/* webpackChunkName: "VendorChargebackScreen" */ '@/components/headerDetail/VendorChargebackScreen.vue');
/* istanbul ignore next */
const VendorEditScreen = () => import(/* webpackChunkName: "VendorEditScreen" */ '@/components/core/mainEdit/VendorEditScreen.vue');
/* istanbul ignore next */
const ProductReorderScreen = () => import(/* webpackChunkName: "ProductReorderScreen" */ '@/components/headerDetail/ProductReorderScreen.vue');
/* istanbul ignore next */
const ProductReorderResultsScreen = () => import(/* webpackChunkName: "ProductReorderResultsScreen" */ '@/components/products/ProductReorderResultsScreen.vue');
/* istanbul ignore next */
const ProductReorderResultsSearchScreen = () => import(/* webpackChunkName: "ProductReorderResultsSearchScreen" */ '@/components/products/ProductReorderResultsSearchScreen.vue');
/* istanbul ignore next */
const BankAccountTranEntry = () => import(/* webpackChunkName: "BankAccountTranEntry" */ '@/components/accounting/BankAccountTranEntry.vue');
/* istanbul ignore next */
const FiscalYearAccountEditScreen = () => import(/* webpackChunkName: "FiscalYearAccountEditScreen" */ '@/components/accounting/FiscalYearAccountEditScreen.vue');
/* istanbul ignore next */
const FiscalYearAccountSearchScreen = () => import(/* webpackChunkName: "FiscalYearAccountSearchScreen" */ '@/components/accounting/FiscalYearAccountSearchScreen.vue');
/* istanbul ignore next */
const ApDisbursementScreen = () => import(/* webpackChunkName: "ApDisbursementScreen" */ '@/components/accounting/ApDisbursementScreen.vue');
/* istanbul ignore next */
const ArDisbursementScreen = () => import(/* webpackChunkName: "ArDisbursementScreen" */ '@/components/accounting/ArDisbursementScreen.vue');
/* istanbul ignore next */
const BankReconciliation = () => import(/* webpackChunkName: "BankReconciliation" */ '@/components/accounting/BankReconciliation.vue');
/* istanbul ignore next */
const InventoryScreen = () => import(/* webpackChunkName: "InventoryScreen" */ '@/components/products/InventoryScreen.vue');
/* istanbul ignore next */
const CustomerSearchScreen = () => import(/* webpackChunkName: "CustomerSearchScreen" */ '@/components/customer/CustomerSearchScreen.vue');
/* istanbul ignore next */
const ReceivingAppointmentScreen = () => import(/* webpackChunkName: "ReceivingAppointmentScreen" */ '@/components/products/ReceivingAppointmentScreen.vue');
/* istanbul ignore next */
const TechnicianScheduleSearchScreen = () => import(/* webpackChunkName: "TechnicianScheduleSearchScreen" */ '@/components/customer/TechnicianScheduleSearchScreen.vue');
/* istanbul ignore next */
const TechnicianScheduleScreen = () => import(/* webpackChunkName: "TechnicianScheduleScreen" */ '@/components/customer/TechnicianScheduleScreen.vue');
/* istanbul ignore next */
const InstallmentContractSearchScreen = () => import(/* webpackChunkName: "InstallmentContractSearchScreen" */ '@/components/customer/installmentContract/InstallmentContractSearchScreen.vue');
/* istanbul ignore next */
const InstallmentContractEditScreen = () => import(/* webpackChunkName: "InstallmentContractEditScreen" */ '@/components/customer/installmentContract/InstallmentContractEditScreen.vue');
/* istanbul ignore next */
const CustomerScreen = () => import(/* webpackChunkName: "CustomerScreen" */ '@/components/customer/CustomerScreen.vue');
/* istanbul ignore next */
const AdjustCommissionsSearchScreen = () => import(/* webpackChunkName: "AdjustCommissionsSearchScreen" */ '@/components/products/AdjustCommissionsSearchScreen.vue');
/* istanbul ignore next */
const CreditApplicationSearchScreen = () => import(/* webpackChunkName: "CreditApplicationSearchScreen" */ '@/components/customer/CreditApplicationSearchScreen.vue');
/* istanbul ignore next */
const CreditApplicationEdit = () => import(/* webpackChunkName: "CreditApplicationEdit" */ '@/components/customer/CreditApplicationEdit.vue');
/* istanbul ignore next */
const SiteDailyBudgetsSearchScreen = () => import(/* webpackChunkName: "SiteDailyBudgetsSearchScreen" */ '@/components/accounting/SiteDailyBudgetsSearchScreen.vue');
/* istanbul ignore next */
const SiteDailyBudgetsEditScreen = () => import(/* webpackChunkName: "SiteDailyBudgetsEditScreen" */ '@/components/accounting/SiteDailyBudgetsEditScreen.vue');
/* istanbul ignore next */
const ReportArchivesScreen = () => import(/* webpackChunkName: "ReportArchivesScreen" */ '@/components/report/ReportArchivesScreen.vue');
/* istanbul ignore next */
const RulesScreen = () => import(/* webpackChunkName: "RulesScreen" */ '@/components/admin/RulesScreen.vue');
/* istanbul ignore next */
const MatchProcess = () => import(/* webpackChunkName: "MatchProcess" */ '@/components/accounting/MatchProcess.vue');
/* istanbul ignore next */
const MagtekPortalScreen = () => import(/* webpackChunkName: "MagtekPortalScreen" */ '@/components/admin/MagtekPortalScreen.vue');
/* istanbul ignore next */
const QueryBuilderScreen = () => import(/* webpackChunkName: "QueryBuilderScreen" */ '@/components/report/QueryBuilderScreen.vue');
/* istanbul ignore next */
const ClassLinkScreen = () => import(/* webpackChunkName: "ClassLinkScreen" */ '@/components/admin/ClassLinkScreen.vue');

const router = createRouter({
  history: createWebHistory(process.env.NODE_ENV === 'production' ? '/ui/' : '/'),
  routes: [{
    path: '/',
    name: 'welcome',
    component: WelcomeScreen,
  },
  {
    path: '/login',
    name: 'login',
    component: LoginScreen,
  },
  {
    path: '/order/new',
    name: 'order_new_screen',
    component: OrderScreen,
    meta: {
      title: 'Order - New',
      classname: 'Order',
      breadcrumbs: [
        { label: 'Orders', name: 'order_search_screen' },
        { label: 'New' },
      ],
    },
  },
  {
    path: '/order/:id',
    name: 'order_edit_screen',
    component: OrderScreen,
    meta: {
      title: 'Order - Edit',
      classname: 'Order',
      breadcrumbs: [
        { label: 'Orders', name: 'order_search_screen' },
        { label: 'Edit' },
      ],
    },
  },
  {
    path: '/TruckRoute',
    name: 'truck_route_search_screen',
    component: TruckRouteSearchScreen,
    meta: {
      title: 'Truck Route - Search',
      classname: 'TruckRoute',
      breadcrumbs: [
        { label: 'Truck Routes' },
      ],
    },
  },
  {
    path: '/TruckRoute/new',
    name: 'truck_route_new_screen',
    component: TruckRouteScreen,
    meta: {
      title: 'Truck Route - New',
      classname: 'TruckRoute',
      breadcrumbs: [
        { label: 'Truck Routes', name: 'truck_route_search_screen' },
        { label: 'New' },
      ],
    },
  },
  {
    path: '/TruckRoute/:id',
    name: 'truck_route_edit_screen',
    component: TruckRouteScreen,
    meta: {
      title: 'Truck Route - Edit',
      classname: 'TruckRoute',
      breadcrumbs: [
        { label: 'Truck Routes', name: 'truck_route_search_screen' },
        { label: 'Edit' },
      ],
    },
  },
  {
    path: '/AdjustCommissions',
    name: 'adjust_commissions_search_screen',
    component: AdjustCommissionsSearchScreen,
    meta: {
      title: 'Adjust Commissions/Spiffs',
      classname: 'OrderDetail',
      permission: 'menuadjustcommissionandspiffs',
      breadcrumbs: [
        { label: 'Adjust Commissions/Spiffs' },
      ],
    },
  },
  {
    path: '/CreditApplication',
    name: 'credit_application_search_screen',
    component: CreditApplicationSearchScreen,
    meta: {
      title: 'Credit Applications - Search',
      classname: 'CreditApplication',
      breadcrumbs: [
        { label: 'Credit Applications' },
      ],
    },
  },
  {
    path: '/CreditApplication/new',
    name: 'credit_application_new_screen',
    component: CreditApplicationEdit,
    meta: {
      title: 'Credit Applications - New',
      classname: 'CreditApplication',
      breadcrumbs: [
        { label: 'Credit Applications', name: 'credit_application_search_screen' },
        { label: 'New' },
      ],
    },
  },
  {
    path: '/CreditApplication/:id',
    name: 'credit_application_edit_screen',
    component: CreditApplicationEdit,
    meta: {
      title: 'Credit Applications - Edit',
      classname: 'CreditApplication',
      breadcrumbs: [
        { label: 'Credit Applications', name: 'credit_application_search_screen' },
        { label: 'Edit' },
      ],
    },
  },
  {
    path: '/Invoice',
    name: 'invoice_search_screen',
    component: InvoiceSearchScreen,
    meta: {
      title: 'Invoice - Search',
      classname: 'Invoice',
      permission: 'menuinvoicequery',
      breadcrumbs: [
        { label: 'Invoices' },
      ],
    },
  },
  {
    path: '/Invoice/new',
    name: 'invoice_new_screen',
    component: InvoiceScreen,
    meta: {
      title: 'Invoice - New',
      classname: 'Invoice',
      permission: 'menuinvoicequery,invoiceedit',
      allPerms: true,
      getDefaults: 'get_nextinvoiceid',
      breadcrumbs: [
        { label: 'Invoices', name: 'invoice_search_screen' },
        { label: 'New' },
      ],
    },
  },
  {
    path: '/Invoice/:id',
    name: 'invoice_edit_screen',
    component: InvoiceScreen,
    meta: {
      title: 'Invoice - Edit',
      classname: 'Invoice',
      permission: 'menuinvoicequery',
      breadcrumbs: [
        { label: 'Invoices', name: 'invoice_search_screen' },
        { label: 'Edit' },
      ],
    },
  },
  {
    path: '/GlTran',
    name: 'gltran_search_screen',
    component: GlTranSearchScreen,
    meta: {
      title: 'G/L Transactions - Search',
      classname: 'GlTran',
      permission: 'menugltrans',
      breadcrumbs: [
        { label: 'G/L Transactions' },
      ],
    },
  },
  {
    path: '/CashDrawerBalance',
    name: 'cash_drawer_balance_search_screen',
    component: CashDrawerBalanceSearchScreen,
    meta: {
      title: 'Cash Drawer Balance - Search',
      classname: 'CashDrawerBalance',
      permission: 'menucashdrawerbalances',
      breadcrumbs: [
        { label: 'Cash Drawer Balances' },
      ],
    },
  },
  {
    path: '/GlReportGroup/new',
    name: 'gl_report_group_new_screen',
    component: GlReportGroupScreen,
    meta: {
      title: 'G/L Report Group - New',
      classname: 'GlReportGroup',
      permission: 'glreportgroupnew',
      breadcrumbs: [
        { label: 'classname', lookupLabel: true, name: 'search_screen' },
        { label: 'New' },
      ],
    },
  },
  {
    path: '/JournalEntry/new',
    name: 'general_journal_entry',
    component: GlEntry,
    meta: {
      title: 'Journal Entry - New',
      classname: 'GlEntry',
      permission: 'menugeneraljournalentry',
      breadcrumbs: [
        { label: 'G/L Journal Entry' },
      ],
    },
  },
  {
    path: '/JournalCode/new',
    name: 'journal_code_new_screen',
    component: JournalCodeScreen,
    meta: {
      title: 'Journal Code - New',
      classname: 'JournalCode',
      breadcrumbs: [
        { label: 'Formatted Journal Codes', name: 'search_screen' },
        { label: 'New' },
      ],
    },
  },
  {
    path: '/JournalCode/:id',
    name: 'journal_code_edit_screen',
    component: JournalCodeScreen,
    meta: {
      title: 'Journal Code - Edit',
      classname: 'JournalCode',
      breadcrumbs: [
        { label: 'Formatted Journal Codes', name: 'search_screen' },
        { label: 'Edit' },
      ],
    },
  },
  {
    path: '/JournalCodeEntry',
    name: 'journal_code_entry',
    component: JournalCodeEntry,
    meta: {
      title: 'Formatted Journal Entry',
      classname: 'JournalCode',
      permission: 'menujournalcodeentry',
      breadcrumbs: [
        { label: 'Formatted Journal Entry' },
      ],
    },
  },
  {
    path: '/ReportTemplate',
    name: 'report_template_search_screen',
    component: ReportTemplateSearchScreen,
    meta: {
      title: 'Report Template - Search',
      classname: 'ReportTemplate',
      permission: 'menureporttemplate,menujobreporttemplate',
      breadcrumbs: [
        { label: 'Templates' },
      ],
    },
  },
  {
    path: '/ReportTemplate/new/',
    name: 'report_template_new_screen',
    component: ReportTemplateEditScreen,
    meta: {
      title: 'Report Template - New',
      classname: 'ReportTemplate',
      permission: 'menureporttemplate,menujobreporttemplate',
      breadcrumbs: [
        { label: 'Templates', name: 'report_template_search_screen' },
        { label: 'New' },
      ],
    },
  },
  {
    path: '/ReportTemplate/:id/',
    name: 'report_template_edit_screen',
    component: ReportTemplateEditScreen,
    meta: {
      title: 'Report Template - Edit',
      classname: 'ReportTemplate',
      permission: 'menureporttemplate,menujobreporttemplate',
      breadcrumbs: [
        { label: 'Templates', name: 'report_template_search_screen' },
        { label: 'Edit' },
      ],
    },
  },
  {
    path: '/TagFormat/new',
    name: 'tag_format_new_screen',
    component: TagFormatScreen,
    meta: {
      title: 'Tag Format - New',
      classname: 'TagFormat',
      permission: 'menutagformat',
      breadcrumbs: [
        { label: 'TagFormat', name: 'search_screen', params: { classname: 'TagFormat' } },
        { label: 'New' },
      ],
    },
  },
  {
    path: '/TagFormat/:id',
    name: 'tag_format_edit_screen',
    component: TagFormatScreen,
    meta: {
      title: 'Tag Format - Edit',
      classname: 'TagFormat',
      permission: 'menutagformat',
      breadcrumbs: [
        { label: 'TagFormat', name: 'search_screen', params: { classname: 'TagFormat' } },
        { label: 'Edit' },
      ],
    },
  },
  {
    path: '/MiscAREntry/',
    name: 'misc_ar_entry',
    component: MiscAREntry,
    meta: {
      title: 'Miscellaneous A/R Entry',
      classname: 'ArTran',
      permission: 'menumiscarentry',
      breadcrumbs: [
        { label: 'Miscellaneous A/R Entry' },
      ],
    },
  },
  {
    path: '/MultiplePaymentsEntry/',
    name: 'multiple_payments_entry',
    component: MultiplePaymentsEntry,
    meta: {
      title: 'Multiple Payments Entry',
      permission: 'menumultiplepaymentsentry',
      breadcrumbs: [
        { label: 'Multiple Payments Entry' },
      ],
    },
  },
  {
    path: '/CashierActivation/',
    name: 'cashier_activation_screen',
    component: CashierActivationScreen,
    meta: {
      title: 'Cashier Activation',
      classname: 'CashDrawerCashCount',
      permission: 'menucashieractivation',
      breadcrumbs: [
        { label: 'Cashier Activation' },
      ],
    },
  },
  {
    path: '/Job',
    name: 'job_search_screen',
    component: ReportSearchScreen,
    meta: {
      title: 'Job - Search',
      classname: 'Report',
      permission: 'menujobs',
      breadcrumbs: [
        { label: 'Jobs' },
      ],
    },
  },
  {
    path: '/Job/new',
    name: 'job_new_screen',
    component: ReportScreen,
    meta: {
      title: 'Job - New',
      classname: 'Report',
      permission: 'menujobs,jobedit',
      allPerms: true,
      breadcrumbs: [
        { label: 'Jobs', name: 'job_search_screen' },
        { label: 'New' },
      ],
    },
  },
  {
    path: '/Job/:id',
    name: 'job_edit_screen',
    component: ReportScreen,
    meta: {
      title: 'Job - Edit',
      classname: 'Report',
      permission: 'menujobs',
      breadcrumbs: [
        { label: 'Jobs', name: 'job_search_screen' },
        { label: 'Edit' },
      ],
    },
  },
  {
    path: '/CashDrawerClose/',
    name: 'cash_drawer_close_screen',
    component: CashDrawerCloseScreen,
    meta: {
      title: 'Cash Drawer Closing',
      classname: 'CashDrawerCashCount',
      permission: 'menuclosedrawer',
      breadcrumbs: [
        { label: 'Cash Drawer Closing' },
      ],
    },
  },
  {
    path: '/Report',
    name: 'report_search_screen',
    component: ReportSearchScreen,
    meta: {
      title: 'Report - Search',
      classname: 'Report',
      permission: 'menureports',
      breadcrumbs: [
        { label: 'Reports' },
      ],
    },
  },
  {
    path: '/Report/new',
    name: 'report_new_screen',
    component: ReportScreen,
    meta: {
      title: 'Report - New',
      classname: 'Report',
      allPerms: true,
      permission: 'menureports,reportedit',
      breadcrumbs: [
        { label: 'Reports', name: 'report_search_screen' },
        { label: 'New' },
      ],
    },
  },
  {
    path: '/Report/:id',
    name: 'report_edit_screen',
    component: ReportScreen,
    meta: {
      title: 'Report - Edit',
      classname: 'Report',
      permission: 'menureports',
      breadcrumbs: [
        { label: 'Reports', name: 'report_search_screen' },
        { label: 'Edit' },
      ],
    },
  },
  {
    path: '/Processes',
    name: 'processes_screen',
    component: ProcessScreen,
    meta: {
      title: 'Processes',
      classname: 'CurrentProcess',
      permission: 'menuprocessesview',
      breadcrumbs: [
        { label: 'Process Monitoring' },
      ],
    },
  },
  {
    path: '/PurchaseOrder',
    name: 'purchase_order_search_screen',
    component: PurchaseOrderSearchScreen,
    meta: {
      title: 'Purchase Order - Search',
      classname: 'PurchaseOrder',
      permission: 'menupurchaseorders',
      breadcrumbs: [
        { label: 'classname', lookupLabel: true },
      ],
    },
  },
  {
    path: '/PurchaseOrder/new',
    name: 'purchase_order_new_screen',
    component: PurchaseOrderScreen,
    meta: {
      title: 'Purchase Order - New',
      classname: 'PurchaseOrder',
      permission: 'menupurchaseorders',
      getDefaults: 'get_nextorderid',
      breadcrumbs: [
        { label: 'Purchase Orders', name: 'purchase_order_search_screen' },
        { label: 'New' },
      ],
    },
  },
  {
    path: '/PurchaseOrder/:id',
    name: 'purchase_order_edit_screen',
    component: PurchaseOrderScreen,
    meta: {
      title: 'Purchase Order - Edit',
      classname: 'PurchaseOrder',
      permission: 'menupurchaseorders',
      breadcrumbs: [
        { label: 'Purchase Orders', name: 'purchase_order_search_screen' },
        { label: 'Edit' },
      ],
    },
  },
  {
    path: '/Transfer',
    name: 'transfer_search_screen',
    component: TransferSearchScreen,
    meta: {
      title: 'Transfer - Search',
      classname: 'Transfer',
      breadcrumbs: [
        { label: 'classname', lookupLabel: true },
      ],
    },
  },
  {
    path: '/Transfer/new',
    name: 'transfer_new_screen',
    component: TransferScreen,
    meta: {
      title: 'Transfer - New',
      classname: 'Transfer',
      permission: 'menutransfer,transfernew',
      allPerms: true,
      getDefaults: 'get_nexttransferid',
      breadcrumbs: [
        { label: 'Transfers', name: 'transfer_search_screen' },
        { label: 'New' },
      ],
    },
  },
  {
    path: '/Transfer/:id',
    name: 'transfer_edit_screen',
    component: TransferScreen,
    meta: {
      title: 'Transfer - Edit',
      classname: 'Transfer',
      breadcrumbs: [
        { label: 'Transfers', name: 'transfer_search_screen' },
        { label: 'Edit' },
      ],
    },
  },
  {
    path: '/TransferWorksheet',
    name: 'transfer_worksheet_entry_screen',
    component: TransferWorksheetEntryScreen,
    meta: {
      title: 'Transfer Worksheet',
      classname: 'PendingTransfer',
      permission: 'menutransferworksheet',
      breadcrumbs: [
        { label: 'Transfer Worksheet Entry' },
      ],
    },
  },
  {
    path: '/InstallmentContract',
    name: 'installment_contract_search_screen',
    component: InstallmentContractSearchScreen,
    meta: {
      title: 'Installment Contract - Search',
      classname: 'InstallmentContract',
      permission: 'menuinstallments',
      breadcrumbs: [
        { label: 'classname', lookupLabel: true },
      ],
    },
  },
  {
    path: '/InstallmentContract/:id',
    name: 'installment_contract_edit_screen',
    component: InstallmentContractEditScreen,
    meta: {
      title: 'Installment Contract - Edit',
      classname: 'InstallmentContract',
      permission: 'menuinstallments',
      breadcrumbs: [
        { label: 'Installment Contracts', name: 'installment_contract_search_screen' },
        { label: 'Edit' },
      ],
    },
  },
  {
    path: '/Customer',
    name: 'customer_search_screen',
    component: CustomerSearchScreen,
    meta: {
      title: 'Customer - Search',
      classname: 'Customer',
      permission: 'menucustomerrec',
      breadcrumbs: [
        { label: 'Customers' },
      ],
    },
  },
  {
    path: '/Customer/new',
    name: 'customer_new_screen',
    component: CustomerScreen,
    meta: {
      title: 'Customer - New',
      classname: 'Customer',
      permission: 'menucustomerrec',
      breadcrumbs: [
        { label: 'Customers', name: 'customer_search_screen' },
        { label: 'New' },
      ],
    },
  },
  {
    path: '/Customer/:id',
    name: 'customer_edit_screen',
    component: CustomerScreen,
    meta: {
      title: 'Customer - Edit',
      classname: 'Customer',
      permission: 'menucustomerrec',
      breadcrumbs: [
        { label: 'Customers', name: 'customer_search_screen' },
        { label: 'Edit' },
      ],
    },
  },
  {
    path: '/ReservedInventory',
    name: 'reserved_inventory_search',
    component: ReservedInventorySearchScreen,
    meta: {
      title: 'Reserved Inventory - Search',
      classname: 'OrderDetail',
      permission: 'menureservedinventoryquery',
      breadcrumbs: [
        { label: 'Reserved Inventory' },
      ],
    },
  },
  {
    path: '/Product',
    name: 'product_search_screen',
    component: ProductSearchScreen,
    meta: {
      title: 'Product - Search',
      classname: 'Product',
      permission: 'menuproductquery',
      breadcrumbs: [
        { label: 'Products' },
      ],
    },
  },
  {
    path: '/ProductLookup',
    name: 'product_lookup_screen',
    component: ProductLookup,
    meta: {
      title: 'Product Lookup',
      classname: 'Product',
      permission: 'menuproductsearch',
      breadcrumbs: [
        { label: 'Product Lookup' },
      ],
    },
  },
  {
    path: '/Product/new',
    name: 'product_new_screen',
    component: ProductEditScreen,
    meta: {
      title: 'Product - New',
      classname: 'Product',
      permission: 'productnew',
      breadcrumbs: [
        { label: 'Products', name: 'product_search_screen' },
        { label: 'New' },
      ],
    },
  },
  {
    path: '/Product/:id',
    name: 'product_edit_screen',
    component: ProductEditScreen,
    meta: {
      title: 'Product - Edit',
      classname: 'Product',
      permission: 'menuproductquery',
      breadcrumbs: [
        { label: 'Products', name: 'product_search_screen' },
        { label: 'Edit' },
      ],
    },
  },
  {
    path: '/Order',
    name: 'order_search_screen',
    component: OrderSearchScreen,
    meta: {
      title: 'Order - Search',
      classname: 'Order',
      breadcrumbs: [
        { label: 'Orders' },
      ],
    },
  },
  {
    path: '/UnrestrictedTransfer',
    name: 'unrestricted_transfer_screen',
    component: UnrestrictedTransferScreen,
    meta: {
      title: 'Unrestricted Transfers',
      classname: 'ArTran',
      permission: 'menuunrestrictedtransfer',
      breadcrumbs: [
        { label: 'Unrestricted Transfers' },
      ],
    },
  },
  {
    path: '/DataGenerator',
    name: 'data_generator_search_screen',
    component: DataGeneratorSearchScreen,
    meta: {
      classname: 'DataGenerator',
      permission: 'menudatagenerators,menujobdatagenerators',
      breadcrumbs: [
        { label: 'Data Generators' },
      ],
    },
  },
  {
    path: '/Inventory',
    name: 'inventory_search_screen',
    component: InventoryScreen,
    meta: {
      title: 'Inventory - Search',
      classname: 'Inventory',
      permission: 'menuinventoryquery',
      viewonly: true,
      breadcrumbs: [
        { label: 'Inventory' },
      ],
    },
  },
  {
    path: '/Inventory/:id',
    name: 'inventory_edit_screen',
    component: DynaformEditScreen,
    meta: {
      title: 'Inventory - View',
      classname: 'Inventory',
      permission: 'menuinventoryquery',
      viewonly: true,
      breadcrumbs: [
        { label: 'Inventory Records', name: 'inventory_search_screen' },
        { label: 'View' },
      ],
    },
  },
  {
    path: '/ReceivingAppointment/new',
    name: 'receiving_appointment_new_screen',
    component: ReceivingAppointmentScreen,
    meta: {
      title: 'Receiving Appointment - New',
      classname: 'ReceivingAppointment',
      breadcrumbs: [
        { label: 'Receiving Appointments', name: 'search_screen' },
        { label: 'New' },
      ],
    },
  },
  {
    path: '/ReceivingAppointment/:id',
    name: 'receiving_appointment_edit_screen',
    component: ReceivingAppointmentScreen,
    meta: {
      title: 'Receiving Appointment - Edit',
      classname: 'ReceivingAppointment',
      breadcrumbs: [
        { label: 'Receiving Appointments', name: 'search_screen' },
        { label: 'Edit' },
      ],
    },
  },
  {
    path: '/TechnicianSchedule/:id',
    name: 'technician_schedules_screen',
    component: TechnicianScheduleScreen,
    meta: {
      title: 'Technician Schedule - Edit',
      classname: 'TechnicianSchedule',
      permission: 'menutechnicianschedules',
      breadcrumbs: [
        { label: 'Technician Schedules', name: 'technician_schedules_search_screen' },
        { label: 'Edit' },
      ],
    },
  },
  {
    path: '/TechnicianSchedule',
    name: 'technician_schedules_search_screen',
    component: TechnicianScheduleSearchScreen,
    meta: {
      title: 'Technician Schedule',
      classname: 'TechnicianSchedule',
      permission: 'menutechnicianschedules',
      breadcrumbs: [
        { label: 'Technician Schedules' },
      ],
    },
  },
  {
    path: '/VendorChargeback',
    name: 'vendor_chargeback_search_screen',
    component: VendorChargebackSearchScreen,
    meta: {
      title: 'Vendor Chargeback - Search',
      classname: 'VendorChargeback',
      permission: 'menuvendorchargebackquery',
      breadcrumbs: [
        { label: 'Vendor Chargebacks' },
      ],
    },
  },
  {
    path: '/VendorChargeback/:id',
    name: 'vendor_chargeback_edit_screen',
    component: VendorChargebackScreen,
    meta: {
      title: 'Vendor Chargeback - Edit',
      classname: 'VendorChargeback',
      permission: 'menuvendorchargebackquery',
      breadcrumbs: [
        { label: 'Vendor Chargebacks', name: 'vendor_chargeback_search_screen' },
        { label: 'Edit' },
      ],
    },
  },
  {
    path: '/VendorChargeback/new',
    name: 'vendor_chargeback_new_screen',
    component: VendorChargebackScreen,
    meta: {
      title: 'Vendor Chargeback - New',
      classname: 'VendorChargeback',
      permission: 'menuvendorchargebackquery',
      getDefaults: 'get_nextchargebackid',
      breadcrumbs: [
        { label: 'Vendor Chargebacks', name: 'vendor_chargeback_search_screen' },
        { label: 'New' },
      ],
    },
  },
  {
    path: '/ProductReorder/new',
    name: 'product_reorder_new_screen',
    component: ProductReorderScreen,
    meta: {
      title: 'Product Reorder - New',
      classname: 'ProductReorder',
      getDefaults: 'get_nextreorderid',
      breadcrumbs: [
        { label: 'Product Reorders', name: 'search_screen' },
        { label: 'New' },
      ],
    },
  },
  {
    path: '/ProductReorder/:id',
    name: 'product_reorder_edit_screen',
    component: ProductReorderScreen,
    meta: {
      title: 'Product Reorder - Edit',
      classname: 'ProductReorder',
      breadcrumbs: [
        { label: 'Product Reorders', name: 'search_screen' },
        { label: 'Edit' },
      ],
    },
  },
  {
    path: '/ProductReorderResult',
    name: 'product_reorder_results_search_screen',
    component: ProductReorderResultsSearchScreen,
    meta: {
      title: 'Product Reorder Result - Search',
      classname: 'ProductReorderResult',
      permission: 'menuproductreorderresults',
      breadcrumbs: [
        { label: 'Product Reorder Results' },
      ],
    },
  },
  {
    path: '/ProductReorderResult/:id',
    name: 'product_reorder_results_screen',
    component: ProductReorderResultsScreen,
    meta: {
      title: 'Product Reorder Result - Edit',
      classname: 'ProductReorderResult',
      permission: 'menuproductreorderresults',
      breadcrumbs: [
        { label: 'Product Reorder Results', name: 'product_reorder_results_search_screen' },
        { label: 'Edit' },
      ],
    },
  },
  {
    path: '/ApDisbursement',
    name: 'ap_disbursement_screen',
    component: ApDisbursementScreen,
    meta: {
      title: 'A/P Disbursements',
      classname: 'Disbursement',
      permission: 'menudisbursementprocess',
      breadcrumbs: [
        { label: 'A/P Disbursements' },
      ],
    },
  },
  {
    path: '/ArDisbursement',
    name: 'ar_disbursement_screen',
    component: ArDisbursementScreen,
    meta: {
      title: 'A/R Disbursements',
      classname: 'Disbursement',
      permission: 'menurefunddisbursementprocess',
      breadcrumbs: [
        { label: 'A/R Disbursements' },
      ],
    },
  },
  {
    path: '/BankAccountTran/new',
    name: 'bank_account_tran_new_screen',
    component: BankAccountTranEntry,
    meta: {
      title: 'Bank Account Transaction - New',
      classname: 'BankAccountTran',
      permission: 'menubankaccounttransactions',
      breadcrumbs: [
        { label: 'Bank Account Transactions', name: 'search_screen' },
      ],
    },
  },
  {
    path: '/BankReconciliation',
    name: 'bank_reconciliation',
    component: BankReconciliation,
    meta: {
      title: 'Bank Reconciliation',
      classname: 'BankAccountReconciliation',
      permission: 'menubankreconciliation',
      breadcrumbs: [
        { label: 'Bank Reconciliation' },
      ],
    },
  },
  {
    path: '/FiscalYearAccount',
    name: 'fiscal_year_account_search_screen',
    component: FiscalYearAccountSearchScreen,
    meta: {
      title: 'Fiscal Year Account - Search',
      classname: 'FiscalYearAccount',
      breadcrumbs: [
        { label: 'Fiscal Year Account Budgets' },
      ],
    },
  },
  {
    path: '/FiscalYearAccount/:id',
    name: 'fiscal_year_account_screen',
    component: FiscalYearAccountEditScreen,
    meta: {
      title: 'Fiscal Year Account - Edit',
      classname: 'FiscalYearAccount',
      breadcrumbs: [
        { label: 'Fiscal Year Account Budgets', name: 'fiscal_year_account_search_screen' },
        { label: 'Edit' },
      ],
    },
  },
  {
    path: '/DataGenerator/new',
    name: 'data_generator_new_screen',
    component: DataGeneratorScreen,
    meta: {
      title: 'Data Generator - New',
      classname: 'DataGenerator',
      permission: 'menudatagenerators,menujobdatagenerators',
      breadcrumbs: [
        { label: 'Data Generators', name: 'data_generator_search_screen' },
        { label: 'New' },
      ],
    },
  },
  {
    path: '/DataGenerator/:id',
    name: 'data_generator_edit_screen',
    component: DataGeneratorScreen,
    meta: {
      title: 'Data Generator - Edit',
      classname: 'DataGenerator',
      permission: 'menudatagenerators,menujobdatagenerators',
      breadcrumbs: [
        { label: 'Data Generators', name: 'data_generator_search_screen' },
        { label: 'Edit' },
      ],
    },
  },
  {
    path: '/Vendor/new',
    name: 'vendor_new_screen',
    component: VendorEditScreen,
    meta: {
      title: 'Vendor - New',
      classname: 'Vendor',
      permission: 'menuvendorchargebackquery,vendoredit',
      allPerms: true,
      breadcrumbs: [
        { label: 'Vendors', name: 'search_screen' },
        { label: 'New' },
      ],
    },
  },
  {
    path: '/Vendor/:id',
    name: 'vendor_edit_screen',
    component: VendorEditScreen,
    meta: {
      title: 'Vendor - Edit',
      classname: 'Vendor',
      breadcrumbs: [
        { label: 'Vendors', name: 'search_screen' },
        { label: 'Edit' },
      ],
    },
  },
  // // dynamic routes must be at the end...
  {
    path: '/GlReportGroup/:id',
    name: 'gl_report_group_edit_screen',
    component: GlReportGroupScreen,
    meta: {
      title: 'G/L Report Group - Edit',
      classname: 'GlReportGroup',
      permission: 'menuglreportgroup',
      breadcrumbs: [
        { label: 'classname', lookupLabel: true, name: 'search_screen' },
        { label: 'Edit' },
      ],
    },
  },
  {
    path: '/SalespersonBudgetPeriod/',
    name: 'salesperson_budget_search_screen',
    component: SalespersonBudgetSearchScreen,
    meta: {
      title: 'Salesperson Budget Period - Search',
      classname: 'SiteBudgetPeriod',
      permission: 'menusalespersonbudgetperiods',
      breadcrumbs: [
        { label: 'Salesperson Budgets' },
      ],
    },
  },
  {
    path: '/SalespersonBudgetPeriod/new',
    name: 'salesperson_budget_period_new_screen',
    component: SalespersonBudgetScreen,
    meta: {
      title: 'Salesperson Budget Period - New',
      classname: 'SiteBudgetPeriod',
      permission: 'menusalespersonbudgetperiods',
      breadcrumbs: [
        { label: 'Salesperson Budgets', name: 'salesperson_budget_search_screen' },
        { label: 'New' },
      ],
    },
  },
  {
    path: '/SalespersonBudgetPeriod/:id',
    name: 'salesperson_budget_period_edit_screen',
    component: SalespersonBudgetScreen,
    meta: {
      title: 'Salesperson Budget Period - Edit',
      classname: 'SiteBudgetPeriod',
      breadcrumbs: [
        { label: 'Salesperson Budgets', name: 'salesperson_budget_search_screen' },
        { label: 'Edit' },
      ],
    },
  },
  {
    path: '/SiteDailyBudget',
    name: 'site_daily_budget_search_screen',
    component: SiteDailyBudgetsSearchScreen,
    meta: {
      title: 'Salesperson Daily Budget - Search',
      classname: 'SiteDailyBudget',
      breadcrumbs: [
        { label: 'Site Daily Budgets' },
      ],
    },
  },
  {
    path: '/SiteDailyBudget/new',
    name: 'site_daily_budget_new_screen',
    component: SiteDailyBudgetsEditScreen,
    meta: {
      title: 'Site Daily Budgets - New',
      classname: 'SiteBudgetPeriod',
      breadcrumbs: [
        { label: 'Site Daily Budgets', name: 'site_daily_budget_search_screen' },
        { label: 'New' },
      ],
    },
  },
  {
    path: '/SiteDailyBudget/:id',
    name: 'site_daily_budget_edit_screen',
    component: SiteDailyBudgetsEditScreen,
    meta: {
      title: 'Site Daily Budgets - Edit',
      classname: 'SiteBudgetPeriod',
      breadcrumbs: [
        { label: 'Site Daily Budgets', name: 'site_daily_budget_search_screen' },
        { label: 'Edit' },
      ],
    },
  },
  {
    path: '/ReportArchive/',
    name: 'report_archives_screen',
    component: ReportArchivesScreen,
    meta: {
      title: 'Report Archive - Search',
      classname: 'ReportArchive',
      breadcrumbs: [
        { label: 'Report Archives' },
      ],
    },
  },
  {
    path: '/ClassRuleList',
    name: 'rules_screen',
    component: RulesScreen,
    meta: {
      title: 'Rules',
      classname: 'ClassRuleList',
      permission: 'menurules',
      breadcrumbs: [
        { label: 'Rules' },
      ],
    },
  },
  {
    path: '/MatchProcess',
    name: 'match_process_screen',
    component: MatchProcess,
    meta: {
      title: 'Match Process',
      classname: 'MatchProcess',
      breadcrumbs: [
        { label: 'Match Process' },
      ],
    },
  },
  {
    path: '/MagTekPortal',
    name: 'magtek_portal_screen',
    component: MagtekPortalScreen,
    meta: {
      title: 'MagTek Portal',
      classname: 'MagtekPortal',
      permission: 'menuemvportal',
      breadcrumbs: [
        { label: 'MagTek Portal' },
      ],
    },
  },
  {
    path: '/QueryBuilder',
    name: 'query_builder_screen',
    component: QueryBuilderScreen,
    meta: {
      title: 'Query Builder',
      permission: 'menuquerybuilder',
      breadcrumbs: [
        { label: 'Query Builder' },
      ],
    },
  },
  {
    path: '/ClassLink/new',
    name: 'class_link_new_screen',
    component: ClassLinkScreen,
    meta: {
      title: 'Class Link - New',
      classname: 'ClassLink',
      breadcrumbs: [
        { label: 'classname', lookupLabel: true, name: 'search_screen' },
        { label: 'New' },
      ],
    },
  },
  {
    path: '/ClassLink/:id',
    name: 'class_link_edit_screen',
    component: ClassLinkScreen,
    meta: {
      title: 'Class Link - Edit',
      classname: 'ClassLink',
      breadcrumbs: [
        { label: 'classname', lookupLabel: true, name: 'search_screen' },
        { label: 'Edit' },
      ],
    },
  },
  {
    path: '/404',
    name: '404',
    component: NotFoundScreen,
  },
  // dynamic routes must be at the end...
  {
    path: '/:classname',
    name: 'search_screen',
    component: DynaformSearchScreen,
    meta: {
      dynaform: true,
      breadcrumbs: [
        { label: 'classname', lookupLabel: true },
      ],
    },
  },
  {
    path: '/:classname/new',
    name: 'new_screen',
    component: DynaformNewScreen,
    meta: {
      dynaform: true,
      breadcrumbs: [
        { label: 'classname', lookupLabel: true, name: 'search_screen' },
        { label: 'New' },
      ],
    },
  },
  {
    path: '/:classname/:id',
    name: 'edit_screen',
    component: DynaformEditScreen,
    meta: {
      dynaform: true,
      breadcrumbs: [
        { label: 'classname', lookupLabel: true, name: 'search_screen' },
        { label: 'Edit' },
      ],
    },
  },
  ],
});

export default router;
